import styled from "styled-components"

export const FooterWrapper = styled.div`
    display: flex;
    width: 100vw;
    justify-content: space-around;
    background-color: #E6F6FF;
    height: 80px;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    align-self: center;
    overflow-x: hidden;

    
    @media(max-width: 1024px){
        width: 100%;
        align-self: center;
    }
    @media(max-width: 768px){
        // width: 60%;
        width: 100%;
        position: relative;
        // bottom: -60px;
        background-color: #E6F6FF;
    }
    @media(max-width: 600px){
        // width: 90%;
        width: 100%;
    }
    @media(max-width: 425px){
        // width: 90%;
        width: 100%;
        flex-direction: column;
    }
`;
export const Copywrite = styled.div`
// background-color: red;
font-size: 12px;
color: #0E8FD8;

@media(max-width: 425px){
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 5px;
    padding-bottom: 5px;
}
`;
export const Connect = styled.div`
// background-color: green;
font-size: 12px;
display: flex;

@media(max-width: 425px){
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 5px;
    padding-bottom: 5px;
}
`;
export const Link = styled.a`
margin-left: 5px;
margin-right: 5px;
cursor: pointer;
font-size: 16px;

@media(max-width: 425px){
    margin-left: 3px;
    margin-right: 3px;
    font-size: 14px;
}
`;
// export const FooterWrapper = styled.div``;
// export const FooterWrapper = styled.div``;
// export const FooterWrapper = styled.div``;